import { render, staticRenderFns } from "./MerchantPricingLookups.vue?vue&type=template&id=3d150c9f"
import script from "./MerchantPricingLookups.vue?vue&type=script&lang=js"
export * from "./MerchantPricingLookups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports